import * as React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { PageContainer } from './PageContainer';
import { Stack } from './Stack';
import { ThemeToggle } from '../ui/ThemeToggle';
import { ClientLogo } from '../branding/ClientLogo';

function cn(...inputs: ClassValue[]) {
 return twMerge(clsx(inputs));
}

type AuthLayoutProps = {
 title: string;
 subtitle?: string;
 children: React.ReactNode;
 className?: string;
 cardClassName?: string;
};

import logoFullUrl from '@repo/ui/assets/logo-full.svg';

export function AuthLayout({ title, subtitle, children, className, cardClassName }: AuthLayoutProps) {
  return (
  <div className={cn('relative min-h-screen bg-bg flex flex-col justify-between', className)}>
  <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_center,color-mix(in_srgb,var(--accent-500)_8%,transparent)_0%,transparent_70%)] pointer-events-none z-base"></div>
  <div className="fixed inset-0 tactical-grid pointer-events-none z-base"></div>
  
  {/* Top Bar / Header */}
  <header className="relative w-full z-sticky flex items-center justify-between px-6 py-4 md:px-8 md:py-6 h-16 border-b border-border/10 sm:border-b-0">
 <div className="flex items-center h-10">
 <a href="/">
 <img src={logoFullUrl} alt="Kraphene" className="h-7 w-auto object-contain" />
 </a>
 </div>
 <div className="flex items-center h-10">
 <ThemeToggle />
 </div>
 </header>

 {/* Page Content / Main */}
 <main className="flex-grow flex items-start sm:items-center justify-center px-6 py-8 sm:px-8 relative z-base w-full">
 <PageContainer size="auth" className="relative z-base max-w-[540px]">
  <div 
  id="auth-card" 
  className={cn(
  "w-full max-w-[480px] flex flex-col justify-center bg-transparent sm:bg-surface-1 border-none sm:border border-border/50 dark:border-border shadow-none sm:shadow-md rounded-none sm:rounded-radius-lg px-0 sm:px-10 py-6 sm:py-12 min-h-none sm:min-h-[540px] animate-[kraphene-fade-in_0.6s_ease-out,slide-up_0.6s_ease-out]",
  cardClassName
  )}
 >
  <Stack gap="8">
  <div className="flex flex-col items-center text-center">
  <ClientLogo variant="full" className="h-9 w-auto object-contain mb-5" />
   <h1 className="text-display-lg sm:text-display-hero font-semibold text-text-primary leading-tight">{title}</h1>
  {subtitle && <p className="text-sm text-text-secondary mt-2">{subtitle}</p>}
  </div>
  {children}
  </Stack>
 </div>
 </PageContainer>
 </main>

 {/* Footer */}
 <footer className="relative w-full flex items-center justify-center gap-2 py-6 md:py-8 z-base">
 <span className="text-caption text-text-muted font-medium">Powered by Kraphene</span>
 <span className="text-accent-500 font-bold text-caption ">&bull;</span>
 <span className="text-caption text-text-muted font-medium">@ 2026</span>
 </footer>
 </div>
 );
}
